import { CHATSOON_SHOW } from './types';

export const chatDialogsShowChatSoonThunkAction = (chId) => ({
  type: CHATSOON_SHOW,
  payload: { channelId: chId },
});
